/* eslint-disable @typescript-eslint/naming-convention */
import axiosInstanceApiGateway from 'config/apiServiceApiGateway'
import { AssetItemType, ReasonType } from '../@types/GenerateAssetId'

type GetAssetListResponseType = {
  data: AssetItemType[]
  pagination: Omit<PaginationType, 'number_of_elements' | 'total_elements'>
}

type AssetPayloadType = {
  asset_code: string
  asset_id: number
  package_id?: number
}

export type PostGenerateAssetRequestType = {
  location_id: number
  assets: AssetPayloadType[]
}

export type GetAssetListRequestType = {
  'pagination.page_size': number
  'pagination.page_index': number
  'filter.asset_code'?: string
  'filter.location_id'?: number
}

export type PutUnassignAssetRequestType = {
  assets: AssetPayloadType[]
  location_id: number
  reason: string
}

type PostPutResponseType = {
  message: string
}

type GetRejectReasonListParamsType = {
  'pagination.page_index': number
  'pagination.page_size': number
  'filter.type'?: string
}

type GetRejectReasonResponseType = {
  data: ReasonType[]
  pagination: {
    direction: string
    page_index: number
    page_size: number
    sort: string
  }
}

export const getRejectReasonList = (params?: GetRejectReasonListParamsType) =>
  axiosInstanceApiGateway.Get<GetRejectReasonResponseType, true>({
    url: '/wims/internal/v1/reasons',
    params,
  })

export const getAssetList = (params: GetAssetListRequestType) =>
  axiosInstanceApiGateway.Get<GetAssetListResponseType, true>({
    url: '/wims/internal/v1/package-ids/assets',
    params,
  })

export const postGenerateAsset = (data: PostGenerateAssetRequestType) =>
  axiosInstanceApiGateway.Post<PostPutResponseType, true>({
    url: '/wims/internal/v1/package-ids/assets',
    data,
  })

export const putUnassignAsset = (data: PutUnassignAssetRequestType) =>
  axiosInstanceApiGateway.Put<PostPutResponseType, true>({
    url: `/wims/internal/v1/package-ids/assets/unassign`,
    data,
  })
